// @flow
import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {usePrefs} from 'docs/data';
import type {Platform, ClientsForPlatform} from 'docs/data/integration-builder';
import {getPlatform} from 'docs/util';
import {Setting} from './Setting';

const messages = defineMessages({
  platform: {
    id: 'docsApp.integrationBuilder.settings.platform',
    description: 'Platform label',
    defaultMessage: 'Platform:',
  },
});

type PlatformSettingProps = {|
  clients: ClientsForPlatform,
|};

export const PlatformSetting = ({clients}: PlatformSettingProps) => {
  const {getPref} = usePrefs();
  const platforms: Array<Platform> = Object.keys(clients);
  let platform: ?Platform = getPref('platform');
  if (!platform || !platforms.includes(platform)) {
    const clientPref = getPref('client') || '';
    platform = getPlatform(clients, clientPref) || platforms[0];
  }

  return (
    <Setting
      label={<FormattedMessage {...messages.platform} />}
      pref="platform"
      activeItem={platform}
      items={platforms}
      getExtraPrefs={(selectedPlatform) => {
        // Making Flow happy again by making sure the selectedPlatform is a Platform
        const newPlatform =
          platforms.find((p) => p === selectedPlatform) || platforms[0];
        const client = clients[newPlatform][0];
        return {client};
      }}
    />
  );
};
